// extracted by mini-css-extract-plugin
export default {"error-container":"error404_error-container__d4eX7"};